import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bc1b4f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px","margin-left":"-12px","font-weight":"900","padding-left":"0px","color":"#606266"} }, "产品相关信息", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px","color":"#c43c07"} }, "（注意！报关资料中的产品名称、规格与计价单位应为工厂开票信息对应，请提前确认！）", -1))
const _hoisted_3 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-22px","color":"#606266"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  cellpadding: "0",
  cellspacing: "0",
  class: "productTable"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "productHeader" }, " 产品中文名称 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "productHeader" }, " 产品英文名称 ", -1))
const _hoisted_8 = {
  key: 0,
  class: "productHeader"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"120px"}
}, " 申报包装数量 ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"120px"}
}, " 包装种类（英） ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "productHeader" }, " 产品规格/型号 ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"110px"}
}, " 成交数量 ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"110px"}
}, " 计价单位 ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"80px"}
}, " 申报币制 ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"115px"}
}, " 申报单价 ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"115px"}
}, " 申报总价 ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"115px"}
}, " 净重/KGS ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"115px"}
}, " 毛重/KGS ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"115px"}
}, "体积/CBM", -1))
const _hoisted_20 = { class: "productData" }
const _hoisted_21 = ["title"]
const _hoisted_22 = { class: "productData" }
const _hoisted_23 = ["title"]
const _hoisted_24 = {
  key: 0,
  class: "productData"
}
const _hoisted_25 = ["title"]
const _hoisted_26 = { class: "productData" }
const _hoisted_27 = ["title"]
const _hoisted_28 = { class: "productData" }
const _hoisted_29 = ["title"]
const _hoisted_30 = { class: "productData" }
const _hoisted_31 = ["title"]
const _hoisted_32 = { class: "productData" }
const _hoisted_33 = ["title"]
const _hoisted_34 = { class: "productData" }
const _hoisted_35 = ["title"]
const _hoisted_36 = { class: "productData" }
const _hoisted_37 = ["title"]
const _hoisted_38 = { class: "productData" }
const _hoisted_39 = ["title"]
const _hoisted_40 = { class: "productData" }
const _hoisted_41 = ["title"]
const _hoisted_42 = { class: "productData" }
const _hoisted_43 = ["title"]
const _hoisted_44 = { class: "productData" }
const _hoisted_45 = ["title"]
const _hoisted_46 = { class: "productData" }
const _hoisted_47 = ["title"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "申报要素、监管信息及其他", -1))
const _hoisted_49 = ["title"]
const _hoisted_50 = ["title"]
const _hoisted_51 = ["title"]
const _hoisted_52 = ["title"]
const _hoisted_53 = { class: "reportTable" }
const _hoisted_54 = {
  key: 0,
  cellpadding: "0",
  cellspacing: "0"
}
const _hoisted_55 = { class: "left" }
const _hoisted_56 = { class: "right" }
const _hoisted_57 = {
  key: 1,
  cellpadding: "0",
  cellspacing: "0"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "2",
    class: "left",
    style: {"width":"100%","height":"30px","line-height":"30px","background-color":"#f5f7fa","color":"#caced5"}
  }, " 暂无HS编码 ")
], -1))
const _hoisted_59 = [
  _hoisted_58
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
    "show-close": false,
    fullscreen: true,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "append-to-body": true
  }, {
    header: _withCtx(({ close }) => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_icon, {
          style: {"cursor":"pointer"},
          onClick: close
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CloseBold)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_component_miezz_form, {
        ref: "ruleFormProduct",
        modelValue: _ctx.form,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form) = $event)),
        fix: true,
        key: _ctx.ruleFormRandom
      }, {
        "form-item": _withCtx(({ item }) => [
          (item.Prop == 'ProductNameZh')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                "label-width": "0px"
              }, {
                default: _withCtx(() => [
                  (item.Prop == 'ProductNameZh')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_el_row, { gutter: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              span: 24,
                              style: {"padding":"0px"}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("table", _hoisted_5, [
                                  _createElementVNode("tr", null, [
                                    _hoisted_6,
                                    _hoisted_7,
                                    (_ctx.isCustomsCode==true)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_8, " 海关代码 "))
                                      : _createCommentVNode("", true),
                                    _hoisted_9,
                                    _hoisted_10,
                                    _hoisted_11,
                                    _hoisted_12,
                                    _hoisted_13,
                                    _hoisted_14,
                                    _hoisted_15,
                                    _hoisted_16,
                                    _hoisted_17,
                                    _hoisted_18,
                                    _hoisted_19
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_20, [
                                      _createElementVNode("div", {
                                        style: {"height":"40px","line-height":"40px","text-align":"center","width":"100% !important","overflow":"hidden"},
                                        title: _ctx.form.Data.ProductNameZh
                                      }, _toDisplayString(_ctx.form.Data.ProductNameZh), 9, _hoisted_21)
                                    ]),
                                    _createElementVNode("td", _hoisted_22, [
                                      _createElementVNode("div", {
                                        style: {"height":"40px","line-height":"40px","text-align":"center","width":"100% !important","overflow":"hidden"},
                                        title: _ctx.form.Data.ProductNameEn
                                      }, _toDisplayString(_ctx.form.Data.ProductNameEn), 9, _hoisted_23)
                                    ]),
                                    (_ctx.isCustomsCode==true)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                                          _createElementVNode("div", {
                                            style: {"height":"40px","line-height":"40px","text-align":"center","width":"100% !important","overflow":"hidden"},
                                            title: _ctx.form.Data.CustomsCode
                                          }, _toDisplayString(_ctx.form.Data.CustomsCode), 9, _hoisted_25)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("td", _hoisted_26, [
                                      _createElementVNode("div", {
                                        style: {"height":"40px","line-height":"40px","text-align":"center","width":"100% !important","overflow":"hidden"},
                                        title: _ctx.form.Data.PackageQuantity
                                      }, _toDisplayString(_ctx.form.Data.PackageQuantity), 9, _hoisted_27)
                                    ]),
                                    _createElementVNode("td", _hoisted_28, [
                                      _createElementVNode("div", {
                                        style: {"height":"40px","line-height":"40px","text-align":"center","width":"100% !important","overflow":"hidden"},
                                        title: _ctx.form.Data.PackageName
                                      }, _toDisplayString(_ctx.form.Data.PackageName), 9, _hoisted_29)
                                    ]),
                                    _createElementVNode("td", _hoisted_30, [
                                      _createElementVNode("div", {
                                        style: {"height":"40px","line-height":"40px","text-align":"center","width":"100% !important","overflow":"hidden"},
                                        title: _ctx.form.Data.SpecName
                                      }, _toDisplayString(_ctx.form.Data.SpecName), 9, _hoisted_31)
                                    ]),
                                    _createElementVNode("td", _hoisted_32, [
                                      _createElementVNode("div", {
                                        style: {"height":"40px","line-height":"40px","text-align":"center","width":"100% !important","overflow":"hidden"},
                                        title: _ctx.form.Data.TransactionQuantity
                                      }, _toDisplayString(_ctx.form.Data.TransactionQuantity), 9, _hoisted_33)
                                    ]),
                                    _createElementVNode("td", _hoisted_34, [
                                      _createElementVNode("div", {
                                        style: {"height":"40px","line-height":"40px","text-align":"center","width":"100% !important","overflow":"hidden"},
                                        title: _ctx.form.Data.ChargeUnit
                                      }, _toDisplayString(_ctx.form.Data.ChargeUnit), 9, _hoisted_35)
                                    ]),
                                    _createElementVNode("td", _hoisted_36, [
                                      (_ctx.form.Data.CurrencySystem)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            style: {"color":"#fe995b","height":"40px","line-height":"40px","text-align":"center","width":"100% !important","overflow":"hidden"},
                                            title: _ctx.form.Data.CurrencySystem.Code
                                          }, _toDisplayString(_ctx.form.Data.CurrencySystem.Code), 9, _hoisted_37))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", _hoisted_38, [
                                      _createElementVNode("div", {
                                        style: {"height":"40px","line-height":"40px","text-align":"center","width":"100% !important","overflow":"hidden"},
                                        title: _ctx.form.Data.UnitPrice
                                      }, _toDisplayString(_ctx.form.Data.UnitPrice), 9, _hoisted_39)
                                    ]),
                                    _createElementVNode("td", _hoisted_40, [
                                      _createElementVNode("div", {
                                        style: {"height":"40px","line-height":"40px","text-align":"center","width":"100% !important","overflow":"hidden"},
                                        title: _ctx.form.Data.TotalPrice
                                      }, _toDisplayString(_ctx.form.Data.TotalPrice), 9, _hoisted_41)
                                    ]),
                                    _createElementVNode("td", _hoisted_42, [
                                      _createElementVNode("div", {
                                        style: {"height":"40px","line-height":"40px","text-align":"center","width":"100% !important","overflow":"hidden"},
                                        title: _ctx.form.Data.NetWeight
                                      }, _toDisplayString(_ctx.form.Data.NetWeight), 9, _hoisted_43)
                                    ]),
                                    _createElementVNode("td", _hoisted_44, [
                                      _createElementVNode("div", {
                                        style: {"height":"40px","line-height":"40px","text-align":"center","width":"100% !important","overflow":"hidden"},
                                        title: _ctx.form.Data.GrossWeight
                                      }, _toDisplayString(_ctx.form.Data.GrossWeight), 9, _hoisted_45)
                                    ]),
                                    _createElementVNode("td", _hoisted_46, [
                                      _createElementVNode("div", {
                                        style: {"height":"40px","line-height":"40px","text-align":"center","width":"100% !important","overflow":"hidden"},
                                        title: _ctx.form.Data.Volume
                                      }, _toDisplayString(_ctx.form.Data.Volume), 9, _hoisted_47)
                                    ])
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, { gutter: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              span: 24,
                              style: {"padding":"0px"}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_48
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, { gutter: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "HS编码",
                                  "label-width": "200px"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.form.Data.HsCode), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "退税率",
                                  "label-width": "200px",
                                  prop: "TaxRate"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.form.Data.TaxRate), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, { gutter: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                (_ctx.form.Data.HsCode!=undefined && _ctx.form.Data.HsCode!='')
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 0,
                                      label: '法定第一计量单位' + '（'  + _ctx.form.Data.StatutoryFirstUnit + '）',
                                      "label-width": "200px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.form.Data.StatutoryFirstUnitValue), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["label"]))
                                  : (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 1,
                                      label: "法定第一计量单位",
                                      "label-width": "200px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.form.Data.StatutoryFirstUnitValue), 1)
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                (_ctx.form.Data.HsCode!=undefined && _ctx.form.Data.HsCode!='')
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 0,
                                      label: '法定第二计量单位' + '（'  + _ctx.form.Data.StatutorySecondUnit + '）',
                                      "label-width": "200px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.form.Data.StatutorySecondUnitValue), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["label"]))
                                  : (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 1,
                                      label: "法定第二计量单位",
                                      "label-width": "200px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.form.Data.StatutorySecondUnitValue), 1)
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, { gutter: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "征免方式",
                                  "label-width": "200px",
                                  prop: "ExemptingModeId"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.form.Data.ExemptingModeName), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "最终目的国（地区）",
                                  "label-width": "200px",
                                  prop: "FinanCountryId"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.form.Data.FinanCountry)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          style: {"height":"30px","line-height":"30px","text-align":"left","width":"100% !important","overflow":"hidden"},
                                          title: _ctx.form.Data.FinanCountry.FullName
                                        }, _toDisplayString(_ctx.form.Data.FinanCountry.FullName), 9, _hoisted_49))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, { gutter: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "原产国（地区）",
                                  "label-width": "200px",
                                  prop: "OriginCountryId"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.form.Data.OriginCountry)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          style: {"height":"30px","line-height":"30px","text-align":"left","width":"100% !important","overflow":"hidden"},
                                          title: _ctx.form.Data.OriginCountry.FullName
                                        }, _toDisplayString(_ctx.form.Data.OriginCountry.FullName), 9, _hoisted_50))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 7 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "境内货源地",
                                  "label-width": "200px",
                                  prop: "DomesticGoodsPlaceId"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.form.Data.DomesticGoodsPlace)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          style: {"height":"30px","line-height":"30px","text-align":"left","width":"100% !important","overflow":"hidden"},
                                          title: _ctx.form.Data.DomesticGoodsPlace.FullName
                                        }, _toDisplayString(_ctx.form.Data.DomesticGoodsPlace.FullName), 9, _hoisted_51))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 5 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "详细地址",
                                  "label-width": "100px"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.form.Data.Place)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          style: {"height":"30px","line-height":"30px","text-align":"left","width":"100% !important","overflow":"hidden"},
                                          title: _ctx.form.Data.Place.FullName
                                        }, _toDisplayString(_ctx.form.Data.Place.FullName), 9, _hoisted_52))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, { gutter: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "备案序号",
                                  "label-width": "200px",
                                  prop: "RecordOrder"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.form.Data.RecordOrder), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "监管条件/监管代码",
                                  "label-width": "200px",
                                  prop: "SupervisionConditionsCode"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.form.Data.SupervisionConditionsCode), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, { gutter: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "申报要素",
                                  "label-width": "200px"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_53, [
                                      (_ctx.form.Data.ProductElements!=null && _ctx.form.Data.ProductElements.length>0)
                                        ? (_openBlock(), _createElementBlock("table", _hoisted_54, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.ProductElements, (p, index) => {
                                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                _createElementVNode("td", _hoisted_55, _toDisplayString(p.Name), 1),
                                                _createElementVNode("td", _hoisted_56, _toDisplayString(p.Value) + "  ", 1)
                                              ]))
                                            }), 128))
                                          ]))
                                        : (_openBlock(), _createElementBlock("table", _hoisted_57, _hoisted_59))
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])),
      _createVNode(_component_miezz_button_bar, {
        modelValue: _ctx.bottomButtons,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bottomButtons) = $event)),
        isBackground: true,
        onHandleClick: _ctx.handleClick
      }, null, 8, ["modelValue", "onHandleClick"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}